import * as React from "react";
import type { SVGProps } from "react";
const SvgPlane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m2.877 15.398 3.817 1.908 1.909 3.817 1.908-1.908v-2.863l3.34-3.34 2.862 8.588 2.863-2.863-2.386-9.065 3.817-3.817a2.024 2.024 0 1 0-2.862-2.862L14.328 6.81 5.263 4.424 2.4 7.287l8.588 2.863-3.34 3.34H4.786z"
    />
  </svg>
);
export default SvgPlane;
